module.exports = __webpack_public_path__ + "img/4.0b7856c2.png";